import type {Dayjs} from 'dayjs'

export const mapEntryEnd = (start: Dayjs, hoursToAdd: number): Dayjs | undefined => {
  if (start.isSame(start.endOf('day'))) return undefined
  if (hoursToAdd <= 0) return undefined

  const end = start.add(hoursToAdd, 'hours')

  if (start.isSame(start.endOf('day'))) return undefined

  const startDay = start.format().substring(0, 10)
  const endDay = end.format().substring(0, 10)

  return startDay === endDay ? end : start.endOf('day')
}
